import React from "react";
import Button from "./Button";

/**
 * DangerButton - Red button for destructive actions
 * 
 * Use for: Delete, Reject, Remove, Archive
 * 
 * @example
 * <DangerButton onClick={handleDelete} loading={isDeleting}>
 *   Delete
 * </DangerButton>
 */
const DangerButton = (props) => {
  return <Button variant="danger" {...props} />;
};

export default DangerButton;

